import React from 'react';
import { useTheme } from '../../theme/ThemeProvider';

const Logo: React.FC = () => {
  const { mode } = useTheme();
  
  // Use different logo based on theme
  const logoSrc = mode === 'dark' ? '/shahsa-logotype-dark.png' : '/shahsa-logotype.png';
  
  return (
    <div className="logo">
      <img 
        src={logoSrc}
        alt="شهسا" 
        style={{ 
          width: '120px', 
          height: '32px',
          objectFit: 'contain'
        }} 
      />
    </div>
  );
};

export default Logo;
